<template>
  <hi-page>
    <hi-page-column card width="25vw">
      <template v-slot:header>
        <hi-row flex>
          <div class="flex-grow-1">EDM Campaigns</div>
          <new-edm-campaign>Add New Campaign</new-edm-campaign> |
          <di-new-group-mail>Add New Group Mail</di-new-group-mail>
        </hi-row>
      </template>
      <!--      <edm-campaign-list></edm-campaign-list>-->
      <v-tabs v-model="tab" background-color="transparent" grow>
        <v-tab>Campaigns</v-tab>
        <v-tab>Group Mails</v-tab>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <edm-campaign-list></edm-campaign-list>
          </v-tab-item>
          <v-tab-item>
            <group-mail-list />
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
      <!--      <template v-slot:footer>Footer</template>-->
    </hi-page-column>
    <router-view></router-view>
    <!--    <hi-sub-page v-if="!currentCampaign">-->
    <hi-sub-page v-if="false">
      <hi-page-column card width="50vw" fix-width>
        <hi-row v-for="event in sgEvents" :key="event.id">
          <span class="ui-text">{{ event.sg_message_id }} - </span>
          <span class="ui-text">{{ event.id }}</span
          ><br />
          <span class="ui-text">
            {{ getTime(event.timestamp) | friendlyTime }}
          </span>
          <span class="ui-text">| event </span>
          <span>{{ event.event }}</span>
          <span class="ui-text">| cat </span>
          <span>{{ event.hive_cat }}</span>
          <span class="ui-text">| type </span>
          <span>{{ event.hive_type }}</span>
          <span class="ui-text">| email </span>
          <span>{{ event.email }}</span>
        </hi-row>
      </hi-page-column>
    </hi-sub-page>
  </hi-page>
</template>
<script>
import HiPage from "@/components/scaffold/HiPage";
import HiPageColumn from "@/components/scaffold/HiPageColumn";
import HiRow from "@/components/scaffold/HiRow";
import NewEdmCampaign from "@/components/edm/NewEdmCampaign";
import EdmCampaignList from "@/components/edm/EdmCampaignList";
import HiSubPage from "@/components/scaffold/HiSubPage";
import { db } from "@/db";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import DiNewGroupMail from "@/components/edm/DiNewGroupMail";
import GroupMailList from "@/components/edm/GroupMailList";

export default {
  name: "EDM",
  components: {
    GroupMailList,
    DiNewGroupMail,
    HiSubPage,
    EdmCampaignList,
    NewEdmCampaign,
    HiRow,
    HiPageColumn,
    HiPage
    // LeadDetails,
    // LeadComments
  },
  data() {
    return {
      campaign: null,
      sgEvents: null,
      tab: null
    };
  },
  methods: {
    ...mapActions("edm", { bindCampaignList: "bindCampaignList" }),
    // selectCampaign(campaign) {
    //   this.campaign = campaign;
    //   this.$router.replace({ path: `/edm/${campaign.id}` });
    // },
    getTime(ts) {
      return moment.unix(ts).toDate();
    }
  },
  firestore: {
    sgEvents: db
      .collection("webhooks/sendGrid/events")
      .orderBy("timestamp", "desc")
  },
  computed: {
    ...mapGetters("edm", ["currentCampaign"])
  },
  created() {
    this.bindCampaignList();
  },
  destroyed() {}
};
</script>
<style lang="scss" scoped>
@import "~@/styles/fullHeightVTabs.scss";
</style>
